import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { useEffect } from 'react'
import { CreateBrokeFlexMessageItemDtoEligibilityType } from '@/modules/messaging/types'
import { notificationItemSchema, type NotificationItemFormData } from '../types'
import { LOCKED_ELIGIBILITY, DEFAULT_ICONS_BY_TYPE } from '../constants'

interface UseItemFormProps {
	isAddingNew: boolean
	itemIndex: number
	currentItem?: NotificationItemFormData
}

export function useItemForm({
	isAddingNew,
	itemIndex,
	currentItem,
}: UseItemFormProps) {
	const form = useForm<NotificationItemFormData>({
		resolver: zodResolver(notificationItemSchema),
		defaultValues: isAddingNew
			? {
					// eslint-disable-next-line @typescript-eslint/no-explicit-any
					type: undefined as any,
					order: itemIndex,
					eligibilityType: CreateBrokeFlexMessageItemDtoEligibilityType.ALWAYS,
					displayName: '',
					icon: '🎁',
					enabled: true,
				}
			: currentItem,
	})

	const selectedType = form.watch('type')

	useEffect(() => {
		if (selectedType) {
			const lockedEligibility = LOCKED_ELIGIBILITY[selectedType]
			form.setValue('eligibilityType', lockedEligibility)

			if (isAddingNew) {
				form.setValue('icon', DEFAULT_ICONS_BY_TYPE[selectedType])
			}
		}
	}, [selectedType, isAddingNew, form])

	return {
		form,
		selectedType,
	}
}
